var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8084_19493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9688 0H7.03125C3.148 0 0 3.148 0 7.03125V16.9688C0 20.852 3.148 24 7.03125 24H16.9688C20.852 24 24 20.852 24 16.9688V7.03125C24 3.148 20.852 0 16.9688 0Z",
    fill: "#FFC12E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 13.2561C13.1509 13.2561 14.2108 12.9313 15.0611 12.3838C15.7155 11.9623 16.5766 12.035 17.1527 12.5581C18.6981 13.962 19.667 15.9889 19.6638 18.2417L19.6623 19.1698C19.6605 20.1294 18.8824 20.9061 17.9228 20.9061H6.08079C5.12126 20.9061 4.34313 20.1289 4.34126 19.1698L4.33985 18.2417C4.33657 15.9894 5.30548 13.9625 6.85095 12.5581C7.42704 12.0345 8.28813 11.9619 8.94251 12.3838C9.79282 12.9313 10.8527 13.2561 12.002 13.2561H12.0016Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0027 11.7084C14.3815 11.7084 16.31 9.77997 16.31 7.40109C16.31 5.02221 14.3815 3.09375 12.0027 3.09375C9.62378 3.09375 7.69531 5.02221 7.69531 7.40109C7.69531 9.77997 9.62378 11.7084 12.0027 11.7084Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8084_19493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.e2c6db799a1302371eac73bcea264f5b.svg";
export { ForwardRef as ReactComponent };